import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { filter, take } from "rxjs/operators";
import { views } from "../../../app/phone/views";
import { OrganizationService } from "@onsip/common/services/api/resources/organization/organization.service";

@Injectable({ providedIn: "root" })
export class E911Resolver {
  constructor(private router: Router, private orgService: OrganizationService) {}

  // we are using the resolver to check for any errors in the org service
  // Since we are enabling orgE911Provisioning on navigation for eligible accounts, we need to make sure the api calls has no errors
  resolve(): Observable<any> {
    return this.orgService.state.pipe(
      filter(state => {
        if (state.loading) return false;
        if (state.errors.length === 0) {
          return true;
        } else {
          console.error(state.errors[0]);
          this.orgService.clearErrors();
          this.router.navigate([views.HOME]);
          return true;
        }
      }),
      take(1)
    );
  }
}
